const ROLES_VALIDOS = [
    "Super Administrador",
    "Soporte",
    "Operador"
];

const MODULOS_VALIDOS = [
    "home", "estado_gral", "cupo", "parametros", "cursos",
    "validaciones", "alumnos", "estado_de_servicio", "novedades",
    "transacciones", "transacciones_fallidas", "eventos"
];

const validadores = {
    esEmailValido: (email: string) => {
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return regex.test(email);
    },
    esNumeroOAsterisco: (valor: any) => {
        return valor === '*' || typeof valor === 'number';
    },
    esStringNoVacio: (valor: string) => {
        return typeof valor === 'string' && valor.trim().length > 0;
    },
    esRolValido: (rol: string) => {
        return ROLES_VALIDOS.includes(rol);
    },
    esHoraValida: (hora: string) => {
        const regex = /^([01]\d|2[0-3]):[0-5]\d$/;
        return typeof hora === 'string' && regex.test(hora);
    }
};

const configuracionValidaciones = {
    'LOGIN_WHITE_LIST': {
        validarEstructura: (data: any) => {
            if (!data || typeof data !== 'object' || !Array.isArray(data.whiteList)) {
                return { esValido: false, error: 'Debe ser un objeto con propiedad "whiteList" que sea un array' };
            }
            return { esValido: true };
        },
        validarElementos: (data: any) => {
            const errores: string[] = [];
            data.whiteList.forEach((item: any, index: number) => {
                if (!item.hasOwnProperty('I') || !item.hasOwnProperty('P') || !item.hasOwnProperty('O')) {
                    errores.push(`Elemento ${index}: Debe tener propiedades I, P, O`);
                    return;
                }
                if (!validadores.esNumeroOAsterisco(item.I)) {
                    errores.push(`Elemento ${index}: I debe ser un número o "*"`);
                }
                if (!validadores.esNumeroOAsterisco(item.P)) {
                    errores.push(`Elemento ${index}: P debe ser un número o "*"`);
                }
                if (!validadores.esNumeroOAsterisco(item.O)) {
                    errores.push(`Elemento ${index}: O debe ser un número o "*"`);
                }
            });
            return errores.length > 0
                ? { esValido: false, errores }
                : { esValido: true };
        }
    },
    'USUARIOS_DASHBOARD': {
        validarEstructura: (data: any) => {
            if (!Array.isArray(data)) {
                return { esValido: false, error: 'Debe ser un array' };
            }
            return { esValido: true };
        },
        validarElementos: (data: any) => {
            const errores: string[] = [];
            data.forEach((usuario: any, index: number) => {
                if (!usuario.hasOwnProperty('mail') || !usuario.hasOwnProperty('rol')) {
                    errores.push(`Usuario ${index}: Debe tener propiedades "mail" y "rol"`);
                    return;
                }
                if (!validadores.esStringNoVacio(usuario.mail)) {
                    errores.push(`Usuario ${index}: El mail debe ser un string no vacío`);
                } else if (!validadores.esEmailValido(usuario.mail)) {
                    errores.push(`Usuario ${index}: "${usuario.mail}" no es un email válido`);
                }
                if (!validadores.esStringNoVacio(usuario.rol)) {
                    errores.push(`Usuario ${index}: El rol debe ser un string no vacío`);
                } else if (!validadores.esRolValido(usuario.rol)) {
                    errores.push(`Usuario ${index}: "${usuario.rol}" no es un rol válido. Roles permitidos: ${ROLES_VALIDOS.join(', ')}`);
                }
            });
            return errores.length > 0
                ? { esValido: false, errores }
                : { esValido: true };
        }
    },
    'PERMISOS_ROLES': {
        validarEstructura: (data: any) => {
            if (typeof data !== 'object' || data === null || Array.isArray(data)) {
                return { esValido: false, error: 'Debe ser un objeto.' };
            }
            return { esValido: true };
        },
        validarElementos: (data: any) => {
            const errores: string[] = [];
            const PREFIJO_ROL = 'role:';

            for (const key in data) {
                if (!key.startsWith(PREFIJO_ROL)) {
                    errores.push(`La clave "${key}" debe empezar con el prefijo "${PREFIJO_ROL}".`);
                    continue;
                }
                const rol = key.substring(PREFIJO_ROL.length);
                if (!validadores.esRolValido(rol)) {
                    errores.push(`El rol "${rol}" extraído de la clave "${key}" no es válido. Roles permitidos: ${ROLES_VALIDOS.join(', ')}.`);
                }

                const modulos = data[key];
                if (typeof modulos !== 'object' || modulos === null || Array.isArray(modulos)) {
                    errores.push(`El valor para "${key}" debe ser un objeto de módulos.`);
                    continue;
                }

                for (const nombreModulo in modulos) {
                    if (!MODULOS_VALIDOS.includes(nombreModulo)) {
                        errores.push(`En "${key}", el módulo "${nombreModulo}" no es válido.`);
                    }

                    const permisos = modulos[nombreModulo];
                    if (!Array.isArray(permisos)) {
                        errores.push(`En "${key}", los permisos para el módulo "${nombreModulo}" deben ser un array.`);
                        continue;
                    }
                    if (permisos.includes('*') && permisos.length > 1) {
                        errores.push(`En "${key}", módulo "${nombreModulo}": si se incluye el permiso "*", no debe haber otros permisos.`);
                    }
                    permisos.forEach((permiso, index) => {
                        if (typeof permiso !== 'string' || permiso.trim().length === 0) {
                            errores.push(`En "${key}", módulo "${nombreModulo}": el permiso en el índice ${index} no es un string válido no vacío.`);
                        }
                    });
                }
            }

            return errores.length > 0
                ? { esValido: false, errores }
                : { esValido: true };
        }
    },
    'USERS': {
        validarEstructura: (data: any) => {
            if (!Array.isArray(data)) {
                return { esValido: false, error: 'Debe ser un array de emails.' };
            }
            return { esValido: true };
        },
        validarElementos: (data: any) => {
            const errores: string[] = [];
            data.forEach((email: any, index: number) => {
                if (!validadores.esStringNoVacio(email)) {
                    errores.push(`Elemento ${index}: El valor debe ser un email (string no vacío).`);
                }
                else if (!validadores.esEmailValido(email)) {
                    errores.push(`Elemento ${index}: "${email}" no es un email válido.`);
                }
            });

            return errores.length > 0
                ? { esValido: false, errores }
                : { esValido: true };
        }
    },
    'FRANJA_HORARIO_CALENDARIO': {
        validarEstructura: (data: any) => {
            if (typeof data !== 'object' || data === null || Array.isArray(data)) {
                return { esValido: false, error: 'Debe ser un objeto.' };
            }
            const keys = Object.keys(data);
            if (!data.hasOwnProperty('desde') || !data.hasOwnProperty('hasta')) {
                return { esValido: false, error: 'Debe contener las propiedades "desde" y "hasta".' };
            }
            if (keys.length !== 2) {
                return { esValido: false, error: 'Solo debe contener las propiedades "desde" y "hasta".' };
            }
            return { esValido: true };
        },
        validarElementos: (data: any) => {
            const errores: string[] = [];
            if (!validadores.esHoraValida(data.desde)) {
                errores.push(`El valor de "desde" ("${data.desde}") no tiene un formato de hora válido (HH:mm).`);
            }
            if (!validadores.esHoraValida(data.hasta)) {
                errores.push(`El valor de "hasta" ("${data.hasta}") no tiene un formato de hora válido (HH:mm).`);
            }
            if (errores.length === 0) {
                if (data.desde >= data.hasta) {
                    errores.push(`La hora "desde" (${data.desde}) debe ser anterior a la hora "hasta" (${data.hasta}).`);
                }
            }

            return errores.length > 0
                ? { esValido: false, errores }
                : { esValido: true };
        }
    },
};

export interface ResultadoValidacion {
    esValido: boolean;
    error?: string;
    errores?: string[];
}

export interface GrupoParametros {
    nombreGrupo: string;
    palabrasClave: string[];
}

// Lista de grupos para agrupar los parámetros en pantalla.
// Un parámetro se asigna al primer grupo cuya lista de palabrasClave
// contenga al menos un substring presente en su clave.
export const gruposParametros: GrupoParametros[] = [
  {
    nombreGrupo: "Sistema",
    palabrasClave: ["ESTADO_SISTEMA", "MANTENIMIENTO", "BY_PASS"],
  },
  {
    nombreGrupo: "Novedades",
    palabrasClave: ["NOVEDADES", "NOVEDAD"],
  },
  {
    nombreGrupo: "Base de datos",
    palabrasClave: ["NEON", "INDICES", "BACKUP", "MIRROR", "CORE_"],
  },
  {
    nombreGrupo: "Acceso y Permisos",
    palabrasClave: [
      "LOGIN",
      "USUARIOS",
      "USERS",
      "PERMISOS",
      "ROLES",
      "WHITE_LIST",
    ],
  },
  {
    nombreGrupo: "Calendario y Horarios",
    palabrasClave: ["HORARIO", "CALENDARIO", "FRANJA", "CRON"],
  },
  {
    nombreGrupo: "Cupos y Reservas",
    palabrasClave: ["CUPO", "RESERVA", "TX", "WEBHOOK", "QUEUE_ORACLE"],
  },
  {
    nombreGrupo: "Cursos y Oferta",
    palabrasClave: ["CURSO", "OFERTA", "INSCRIP", "AULA"],
  },
  {
    nombreGrupo: "Notificaciones",
    palabrasClave: ["NOTIFICACION", "MAIL", "EMAIL", "ALERTA"],
  },
  {
    nombreGrupo: "Validaciones",
    palabrasClave: ["VALIDACION", "VALIDACIONES"],
  },
];

export interface ParametroAgrupado<T> {
    nombreGrupo: string;
    parametros: T[];
}

// Agrupa una lista de parámetros (con propiedad `clave`) según la
// configuración hardcodeada de `gruposParametros`. Los parámetros que
// no coinciden con ningún grupo se devuelven bajo el grupo "Otros".
export const agruparParametros = <T extends { clave: string }>(
    parametros: T[]
): ParametroAgrupado<T>[] => {
    const grupos: ParametroAgrupado<T>[] = gruposParametros.map((g) => ({
        nombreGrupo: g.nombreGrupo,
        parametros: [],
    }));
    const otros: T[] = [];

    parametros.forEach((p) => {
        const idx = gruposParametros.findIndex((g) =>
            g.palabrasClave.some((palabra) => p.clave.includes(palabra))
        );
        if (idx >= 0) {
            grupos[idx].parametros.push(p);
        } else {
            otros.push(p);
        }
    });

    const resultado = grupos.filter((g) => g.parametros.length > 0);
    if (otros.length > 0) {
        resultado.push({ nombreGrupo: "Otros", parametros: otros });
    }
    return resultado;
};

export const validarParametro = (clave: string, valor: string): ResultadoValidacion => {
    const configuracion = configuracionValidaciones[clave as keyof typeof configuracionValidaciones];
    if (!configuracion) {
        return { esValido: true };
    }
    let data;
    try {
        data = JSON.parse(valor);
    } catch (error) {
        return { esValido: false, error: 'JSON inválido' };
    }
    const resultadoEstructura = configuracion.validarEstructura(data);
    if (!resultadoEstructura.esValido) {
        return resultadoEstructura;
    }
    const resultadoElementos = configuracion.validarElementos(data);
    if (!resultadoElementos.esValido) {
        const mensajeError = resultadoElementos.errores?.join(', ') || 'Error en validación de elementos';
        return { esValido: false, error: mensajeError };
    }

    return { esValido: true };
};